import { AssistantCitation } from '@services/modules/AssistantStream'
import { observer } from 'mobx-react'

import { useAssistantSession } from './AssistantSessionContext'
import { openCitation } from './citationNavigation'
import { citationRoute } from './citationRoutes'
import { useAssistantPlacement } from './placements/PlacementContext'
import { CitationPill, MetaRow } from './ui'

interface Props {
  citations: AssistantCitation[]
}

/**
 * Server-built citations only — deep links to the source records the answer's text does not
 * name itself (those are links in the text). Clicking opens the record in a dashboard tab (SPA
 * navigation, no reload). A record whose screen is the one the placement sits in is not
 * offered there (placement.hidesLink).
 */
const CitationChips = ({ citations }: Props) => {
  const session = useAssistantSession()
  const { hidesLink } = useAssistantPlacement()
  const shown = hidesLink
    ? citations.filter(citation => {
        const path = citationRoute(
          citation.type,
          citation.id,
          citation.label
        )?.path
        return (
          typeof path !== 'string' || !hidesLink(path, session.placementContext)
        )
      })
    : citations
  if (!shown.length) {
    return null
  }
  return (
    <MetaRow>
      {shown.map(citation => (
        <CitationPill
          key={`${citation.type}-${citation.id}`}
          title="Open the source record"
          onClick={() => openCitation(citation)}
        >
          {citation.label}
        </CitationPill>
      ))}
    </MetaRow>
  )
}

export default observer(CitationChips)
